import { IOrgao, IOrgaoVinculado } from "../../Orgaos/interfaces";

interface IContrato {
    id: number;
    uuid: string;
    nome: string;
    vigencia: string;
    vigenciaAtual: string;
    validadeTeste: string | null;
    ativo: boolean;
    planoId: number;
    createdAt: string;
    updatedAt: string;
    statusDoModulo: string;
}

export enum ETipoAtributoConfiguracaoContabil {
    STRING = "string",
    ENUM = "enum",
    BOOLEAN = "boolean",
    NUMBER = "number",
    ARRAY = "array",
}

export interface IAtributoConfiguracaoContabil {
    nome: string;
    nomeNorm: string;
    tipo: ETipoAtributoConfiguracaoContabil;
    tipoArray: 'string' | 'number';
    options?: string[];
}

export interface ISistemaContabil {
    id: number;
    createdAt: string;
    updatedAt: string;
    tipo_integracao: string;
    nome: string;
    observacao: string | null;
    qtdeDigitosFonteRecurso: number | null;
    atributosConfiguracao: IAtributoConfiguracaoContabil[];
}

export interface IEtapaSolicitacaoAtivacao {
    id: number;
    createdAt: string;
    updatedAt: string;
    etapa: {
        id: number;
        createdAt: string;
        updatedAt: string;
        nome: string;
        nomeIcone: string;
        descricao: string;
        ordem: number;
    },
    iniciadaEm: string | null;
    concluidaEm: string | null;
    observacao: string | null;
}

export interface ISolicitacaoAtivacaoListItem {
    id: number;
    createdAt: string;
    updatedAt: string;
    contrato: IContrato;
    contratoId: number;
    iniciadaEm: string;
    concluidaEm: null;
    observacao: null;
    sistemaContabil: ISistemaContabil;
    sistemaContabilId: number;
    sistemaContabilOutro: string | null;
    etapasSolicitacaoAtivacao: IEtapaSolicitacaoAtivacao[];
    etapaAtual: IEtapaSolicitacaoAtivacao | null;
    empenhosERestos: boolean;
    possuiContasInativas: boolean;
}

export interface ISolicitacaoAtivacao {
    id: number;
    createdAt: string;
    updatedAt: string;
    contrato: IContrato;
    contratoId: number;
    iniciadaEm: string;
    concluidaEm: null;
    observacao: null;
    sistemaContabil: ISistemaContabil;
    sistemaContabilId: number;
    sistemaContabilOutro: string | null;
    etapasSolicitacaoAtivacao: IEtapaSolicitacaoAtivacao[];
    orgao: IOrgao;
    empenhosERestos: boolean;
    tipoEmpenhosERestos: string;
    configuracaoContabil: IConfiguracaoContabil | null;
}

export interface IBancoSaldoDeContas {
    id: number;
    createdAt: string;
    updatedAt: string;
    nome: string;
    nomeNormalizado: string;
    sigla: string;
    tipo_integracao: string;
    img_url: string | null;
    pluggyOpenFinanceConnectorId: number | null;
}

export interface IFonteSaldoDeContas {
    id: number;
    createdAt: string;
    updatedAt: string;
    descricao: string;
    descricaoNormalizada: string;
    numero: string;
    favorita: boolean;
    categoriaId: number;
    categoria: ICategoria;
}

export interface IFonteVinculadaSaldoDeContas {
    id: number;
    createdAt: string;
    updatedAt: string;
    contaId: number;
    fonteId: number;
    orgaoVinculadoId: number;
    categoriaId: number;
    fonte: IFonteSaldoDeContas;
}

export interface IContaSaldoDeContas {
    id: number;
    createdAt: string;
    updatedAt: string;
    descricao: string;
    numero: string;
    agencia: string;
    integrada: boolean;
    ativa: boolean;
    encerradaEm: string | null;
    bancoId: number;
    orgaoVinculadoId: number;
    banco: IBancoSaldoDeContas;
    orgaoVinculado: IOrgaoVinculado;
    fontesConta: IFonteVinculadaSaldoDeContas[];
    planilha: { id: number } | null;
}

export interface IPlanilhaSaldoDeContas {
    id: number;
    createdAt: string;
    updatedAt: string;
    originalName: string;
    fileName: string;
    bucket: string;
}

export interface IOrgaoAutorizacaoItem {
    id: number;
    cnpj: string;
    nome: string;
    autorizacaoBB: IAutorizacao | null;
    concluidaEm: string | null;
}

export interface ICredencialBB {
    id: number;
    createdAt: string;
    updatedAt: string;
    basic: string;
    appKey: string;
    clientId: string;
    clientSecret: string;
    orgaoVinculadoId: number;
}

export interface IAutorizacao {
    id: number;
    createdAt: string;
    updatedAt: string;
    pluggyItemId: string | null;
    bbItemId: string;
    bbVersaoApi: number;
    bancoId: number;
    orgaoVinculadoId: number;
    concluidaEm: string | null;
    solicitacaoAtivacaoId: number;
    credencialBB: ICredencialBB | null;
}

export interface IContaComErro {
    id: number;
    createdAt: string;
    updatedAt: string;
    descricao: string;
    numero: string;
    agencia: string;
    integrada: boolean;
    ativa: boolean;
    com_erro_integracao: boolean;
    bancoId: number;
    orgaoVinculadoId: number;
}

export interface IBancoComErro {
    id: number;
    nome: string;
    tipoIntegracao: string;
    pluggyOpenFinanceConnectorId: number | null;
    autorizado: boolean;
    autorizado_em: string;
    solicitado: boolean;
    solicitado_em: string;
    integrado: boolean;
    imageUrl: string | null;
    contas: IContaComErro[];
}

export interface IOrgaoComErro {
    id: number;
    nome: string;
    cnpj: string;
    autorizado: boolean;
    integrado: boolean;
    bancos: IBancoComErro[];
}

export interface IUsuarioSolicitacao {
    id: number;
    nome: string;
    cargo: string
    createdAt: string;
    updatedAt: string;
    categorias: ICategoria[];
}

export interface ICategoria {
    id: number;
    createdAt: string;
    updatedAt: string;
    nome: string;
    nomeNormalizado: string;
}

export interface IConfiguracaoContabil {
    id: number;
    createdAt: string;
    updatedAt: string;
    stn: boolean;
    userAccess: string | null;
    siteTransparencia: string | null;
    qtdeDigitosFonteRecurso: number | null;
    idEntidade: number | null;
    cnpj: string | null;
    accessToken: string | null;
    idsEntidade: number[];
}
